import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgEyeCloseIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M3 12c.714 2.48 3 7 9 7 5.496 0 8.286-4.813 9-7"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgEyeCloseIcon);
const Memo = memo(ForwardRef);
export default Memo;
